// extracted by mini-css-extract-plugin
module.exports = {"isActive":"EnergyDeviceSensorsList_isActive__1RIl1","isInactive":"EnergyDeviceSensorsList_isInactive__2UnNP"};